import { useIonViewWillEnter, IonChip, IonRefresher, IonRefresherContent, IonCardContent, IonText, IonGrid, IonRow, IonCol, IonBackButton, IonButton, IonButtons, IonCard, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import React, { useState } from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

import './Main.css'; 
import { LANGUAGE, GetStr, LoadLanguage } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer, { UIElement } from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
            position: 'top' as const,
        }
    },
};

const labels = ['10', '20', '30', '40', '50', '60', '70', '80', '90', '100'];

export const dataDef = {
    labels,
        datasets: [
        {
            label: 'USD',
            data: [65, 59, 80, 81, 56, 55, 40, 22, 89, 60],
            borderColor: 'rgb(132, 200, 92)',
            backgroundColor: 'rgba(132, 255, 92, 0.5)',
        }
    ],
};

var xrateDuration : string = "1m";

const ExchangeRate : React.FC = () => {
    
    const [xrate, setXRate] = useState(0);
    const [data, setData] = useState<any>(dataDef);
    const [updateTime, setUpdateTime] = useState("---");
    const [durations, setDurations] = useState<string[]>([]);

    useIonViewWillEnter(() => {
        Refresh();
    });

    const Refresh = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            duration: xrateDuration
        }

		var server = new NServer();
        await server.getList("nc_buy_xrate", state);

        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            setXRate(server.data.rate);
            setUpdateTime(server.data.updated);
            setData(server.data.chart);
            setDurations(server.data.durations);
        }
    };

    // set the duration
    const durationChange = (dur : string) => {
        xrateDuration = dur;
        Refresh();
    }

    const doRefresh = async (ev : any) => {
        await Refresh();
        ev.detail.complete();
    }

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                <IonToolbar color="none">
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/ntkbuy" ></IonBackButton>
                    </IonButtons>
                    <IonTitle className="title"><h5>{GetStr(LANGUAGE.TXT_EXCHANGE_RATE_CAP)}</h5></IonTitle>
                </IonToolbar>
                <IonGrid className="ion-no-padding main-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="10" size-lg="8" size-xl="6" size="12">
                            <IonCard className="flat-card">
                                <IonCardContent className="ion-text-center">
                                    <p><IonText><b>{ GetStr(LANGUAGE.TXT_EXCHANGE_RATE_CAP) }</b></IonText></p>
                                    <p><small>{ GetStr(LANGUAGE.TXT_USD_NTK_EXCHANGE_RATE) }</small></p>
                                    <p><IonText className="balance-text" color="primary"><b>{ xrate }</b></IonText></p>
                                    <p><small className="ion-float-right">{ GetStr(LANGUAGE.TXT_UPDATED_TIME) } {updateTime}</small></p><br/>
                                </IonCardContent>
                            </IonCard>

                            <IonCard className="line-chart flat-card">
                                <Line options={options} data={data} />
                            </IonCard>

                            <div className="ion-padding ion-text-center">
                            {
                                durations.map((m : string, index : number) => 
                                    <IonChip key={index} onClick={()=>{ durationChange(m) } }>{ m }</IonChip>)
                            }
                            </div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );

};

export default ExchangeRate;